import React from 'react';

const Workshop = () =>{
    return(
        <div>
            <div className="my-5 " id="workshop">
                <h4 className="text-2xl font-medium mb-5">The CodeOne Workshop 2025</h4>
                <p >The CodeOne Workshop 2025 will take place online in form of interactive seminars every friday from the 17th of October until the 31st of October 2025 from 7.30 p.m. to 9.30 p.m. every night
                (the last 30 minutes being dedicated for QnA). The three-day workshop will be covering the basics of web application building (more details below). 
                The workshop is FREE and open for any SMAKONE 10th, 11th, and 12th grader. We are going to start from the basics and no previous experience is needed. 
                You are not required to attend all seminars, though it is highly recommended that you do as the seminars will build upon one another. The seminars 
                will be recorded and handouts will be distributed every morning so you can prepare beforehand. After the last day, there will be a take-home project where you 
                could test out the skills that you have learned. For those interested in joining CodeOne an interview will also be conducted afterwards 
                which alongside your challenge project will be considered for your admission to CodeOne.</p>
            </div>
            <hr/>
        </div>
    )
}
export default Workshop